import { createContext } from 'react';

import type { SankeyLayoutModel } from '../types/sankey-internal.js';

export const SankeyLayoutContext = createContext<SankeyLayoutModel>({
  nodes: [],
  links: [],
});

SankeyLayoutContext['displayName'] = 'SankeyLayoutContext';
